module.exports = __webpack_public_path__ + "static/meta/sqs/2018/layout_metadata.8d0ef9a.tsv";


//////////////////
// WEBPACK FOOTER
// ./src/components/sqs/2018/meta/layout_metadata.tsv
// module id = JKeq
// module chunks = 0